import React, { useId } from 'react';
import { Switch } from '@/components/ui/switch';

/**
 * "Plan mode" beside Build. On: Build drafts the site's pages to review and
 * change — free — before the credit is spent. Off: Build starts the site
 * straight away.
 *
 * Called "Plan first" until people kept calling it plan mode, which is the
 * better name for what it now is: a step you can stay in, change, and talk to.
 * A switch rather than a question on every click: most people starting their
 * first site would not know which to pick, and the safe answer is the default.
 * The label is part of the control, so clicking the words flips it too.
 */
export default function PlanFirstToggle({ checked, onCheckedChange, className = '' }) {
  const id = useId();
  const hint = checked
    ? 'Review and change the plan for free before anything is built.'
    : 'Build starts straight away, with no plan to review.';
  return (
    <div className={`flex items-center gap-2 shrink-0 ${className}`} title={hint}>
      <Switch
        id={id}
        checked={checked}
        onCheckedChange={onCheckedChange}
        className="data-[state=checked]:bg-orange-500 data-[state=unchecked]:bg-zinc-700"
      />
      <label htmlFor={id} className="text-xs text-zinc-400 hover:text-zinc-200 cursor-pointer select-none whitespace-nowrap">
        Plan mode
      </label>
    </div>
  );
}
